export type MapPoint = { x: number; y: number };
export type MapView = MapPoint & { zoom: number };

export const MIN_MAP_ZOOM = 0.2;
export const MAX_MAP_ZOOM = 2;

export function clampMapZoom(zoom: number) {
  return Math.max(MIN_MAP_ZOOM, Math.min(MAX_MAP_ZOOM, zoom));
}

export function zoomAtPoint(view: MapView, nextZoom: number, point: MapPoint): MapView {
  const zoom = clampMapZoom(nextZoom);
  const ratio = zoom / view.zoom;
  return {
    zoom,
    x: point.x - (point.x - view.x) * ratio,
    y: point.y - (point.y - view.y) * ratio,
  };
}

export function segmentsProperlyCross(
  a: MapPoint,
  b: MapPoint,
  c: MapPoint,
  d: MapPoint,
) {
  const orientation = (p: MapPoint, q: MapPoint, r: MapPoint) =>
    (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x);
  const abC = orientation(a, b, c);
  const abD = orientation(a, b, d);
  const cdA = orientation(c, d, a);
  const cdB = orientation(c, d, b);
  return abC * abD < 0 && cdA * cdB < 0;
}
